export default "__VITE_ASSET__BhRWI5Wq__"